import { useMutation } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/analytics/requestTypes'
import { analyticsKeys } from '@core/react-query/features/analytics'
import { IDownloadAnalyticsDashboard } from '@core/entities/analytics'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDownloadAnalyticsDashboard = () => {
  return useMutation<
    IDownloadAnalyticsDashboard,
    RequestErrorType,
    RequestTypes['downloadAnalyticsDashboard'],
    unknown
  >({
    mutationFn: (variables: RequestTypes['downloadAnalyticsDashboard']) =>
      analyticsKeys.downloadAnalyticsDashboard(variables).queryFn(undefined),
  })
}
